import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { track } from "../lib/analytics";
import { getConsent, CONSENT_EVENT } from "../lib/consent";

const labelFor = (a) => {
  const href = a.getAttribute("href") || "";
  const text = (a.textContent || "").trim().slice(0, 60);
  if (href.includes("elev.citytrafikskolauppsala.se/login")) return "Elevinloggning";
  if (href.includes("elev.citytrafikskolauppsala.se/shop/kurser")) return "Kursbokning";
  if (href.includes("elev.citytrafikskolauppsala.se")) return `Boka online: ${text}`;
  if (href.startsWith("tel:")) return "Ring";
  if (href.startsWith("mailto:")) return "Mejla";
  if (href.includes("apps.apple.com")) return "App Store";
  if (href.includes("play.google.com")) return "Google Play";
  if (href.includes("facebook.com") || href.includes("instagram.com")) return "Sociala medier";
  if (href.includes("google.com") && href.includes("review")) return "Google-omdömen";
  return null;
};

export default function AnalyticsTracker() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname.startsWith("/admin")) return;
    track("pageview");
  }, [pathname]);

  useEffect(() => {
    const onConsent = (e) => {
      track("consent", { label: e.detail?.statistik ? "accepterat" : "avböjt", meta: { statistik: !!e.detail?.statistik } }, { force: true });
      if (e.detail?.statistik && !getConsent().statistik) track("pageview");
    };
    const onClick = (ev) => {
      const a = ev.target.closest?.("a[href]");
      if (!a) return;
      const label = labelFor(a);
      if (label) track("click", { label });
    };
    window.addEventListener(CONSENT_EVENT, onConsent);
    document.addEventListener("click", onClick, true);
    return () => { window.removeEventListener(CONSENT_EVENT, onConsent); document.removeEventListener("click", onClick, true); };
  }, []);

  return null;
}
